"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _Input = _interopRequireDefault(require("./components/Input"));

var _Textarea = _interopRequireDefault(require("./components/Textarea"));

var _Select = _interopRequireDefault(require("./components/Select"));

var _SubmitButton = _interopRequireDefault(require("./components/SubmitButton"));

var _GenderSwitch = _interopRequireDefault(require("./components/GenderSwitch"));

function Form(props) {
  var className = props.className,
      children = props.children,
      formik = props.formik;
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react["default"].createElement(_formik.Formik, formik, /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: className
    }, children))
  );
}

var _default = Object.assign(Form, {
  Input: _Input["default"],
  Textarea: _Textarea["default"],
  Select: _Select["default"],
  SubmitButton: _SubmitButton["default"],
  GenderSwitch: _GenderSwitch["default"]
});

exports["default"] = _default;